module.exports = __webpack_public_path__ + "img/LibCity_demo.5f1173ec.png";